<table style="width: 100%">
  <tr>
    <td>
      <ng-container *ngIf="!didComplete">
        <b>{{ status }}, {{progress}}% Complete.</b>
      </ng-container>
      <ng-container *ngIf="didComplete">
        <ng-container *ngIf="hasError">
          <b>Error Generating Report:</b>
        </ng-container>
        <ng-container *ngIf="!hasError">
          <b>Report Generated:</b>
        </ng-container>
      </ng-container>
    </td>
    <td style="text-align: right">
      <ng-container *ngIf="didComplete">
        <a href="#" (click)="close()"><i class="fas fa-window-close"></i></a>
      </ng-container>
    </td>
  </tr>
  <tr>
    <td>
      <ng-container *ngIf="!didComplete">
        <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
      </ng-container>
      <ng-container *ngIf="didComplete">
        <ng-container *ngIf="hasError">
          Error Logged, Please Contact Support.
        </ng-container>
        <ng-container *ngIf="!hasError">
          <a href="#" (click)="downloadReport()">Download Report</a>
        </ng-container>
      </ng-container>
    </td>
    <td>
    </td>
  </tr>
</table>
